(function() {
    // Prevent double execution
    if (window.complementaryProductFixLoaded) {
        return;
    }
    window.complementaryProductFixLoaded = true;

    const ComplementaryProductFix = {
        isProcessing: false,
        initialized: false,
        klaviyoConfig: {
            account: "JvLgcE",
            platform: "shopify",
            modalConfig: {
                trigger: {
                    product_page_text: "JOIN WAITLIST",
                    product_page_class: "button button--outline",
                    product_page_text_align: "center",
                    product_page_margin: "0px",
                    replace_anchor: false
                },
                modal: {
                    body_content: "Register to receive a notification when this item comes back in stock.",
                    email_field_label: "Email",
                    button_label: "Notify me when available",
                    subscription_success_label: "You're in! We'll let you know when it's back.",
                    footer_content: '',
                    additional_styles: "@import url('https://fonts.googleapis.com/css?family=century');",
                    drop_background_color: "#000",
                    background_color: "#fff",
                    text_color: "#222",
                    button_text_color: "#fff",
                    button_background_color: "#000",
                    close_button_color: "#ccc",
                    error_background_color: "#fcd6d7",
                    error_text_color: "#C72E2F",
                    success_background_color: "#d3efcd",
                    success_text_color: "#1B9500"
                }
            }
        },
        klaviyoScriptLoaded: false,

        loadKlaviyoScript: function() {
            if (this.klaviyoScriptLoaded) {
                return Promise.resolve();
            }

            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
                script.async = true;
                script.onload = () => {
                    this.klaviyoScriptLoaded = true;
                    resolve();
                };
                document.head.appendChild(script);
            });
        },

        enhanceComplementaryVariantPickers: function() {
            if (this.isProcessing) return;
            this.isProcessing = true;

            const variantPickers = document.querySelectorAll('variant-picker');
            if (!variantPickers || variantPickers.length < 2) {
                this.isProcessing = false;
                return;
            }
            
            const complementaryPicker = variantPickers[1];
            if (!complementaryPicker || complementaryPicker.hasAttribute('data-enhanced')) {
                this.isProcessing = false;
                return;
            }
            
            complementaryPicker.setAttribute('data-enhanced', 'true');
            complementaryPicker.setAttribute('data-is-complementary', 'true');
            complementaryPicker.setAttribute('form-id', 'product-form-complementary');
            
            this.setupInitialVariant(complementaryPicker);
            this.setupEventListeners(complementaryPicker);
            this.isProcessing = false;
        },

        observeVariantPickerChanges: function(picker) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' || mutation.type === 'subtree') {
                        this.setupEventListeners(picker);
                    }
                });
            });

            observer.observe(picker, {
                childList: true,
                subtree: true
            });
        },

        getAllVariants: function(picker) {
            const variants = [];
            const variantScripts = picker.querySelectorAll('script[data-variant]');
            
            variantScripts.forEach(script => {
                try {
                    const variantData = JSON.parse(script.textContent);
                    if (!variants.some(v => v.id === variantData.id)) {
                        variants.push(variantData);
                    }
                } catch (e) {
                    console.error('Error parsing variant data:', e);
                }
            });

            return variants;
        },

        getSelectedVariantId: function(picker) {
            const selectedInputs = picker.querySelectorAll('input[type="radio"]:checked');
            if (!selectedInputs.length) {
                return null;
            }

            const productHandle = picker.getAttribute('handle') || 
                                picker.closest('form')?.getAttribute('data-product-handle');

            if (!productHandle) {
                return null;
            }

            return fetch(`${Shopify.routes.root}products/${productHandle}.js`)
                .then(response => response.json())
                .then(productData => {
                    const selectedOptions = Array.from(selectedInputs).map(input => {
                        const optionPosition = input.getAttribute('name').match(/option(\d+)/)?.[1];
                        const optionIndex = parseInt(optionPosition) - 1;
                        const optionName = productData.options[optionIndex]?.name || '';
                        
                        const label = picker.querySelector(`label[for="${input.id}"]`);
                        const optionValue = label ? label.textContent.trim() : input.value;

                        return {
                            name: optionName,
                            value: optionValue,
                            position: optionPosition
                        };
                    });

                    const matchingVariant = productData.variants.find(variant => {
                        return selectedOptions.every(option => {
                            const variantValue = variant[`option${option.position}`];
                            return variantValue === option.value;
                        });
                    });

                    return matchingVariant?.id || null;
                })
                .catch(error => {
                    console.error('Error fetching product data:', error);
                    return null;
                });
        },

        setupEventListeners: function(picker) {
            picker.removeEventListener('change', this.handleVariantChange);
            picker.addEventListener('change', this.handleVariantChange.bind(this));
        },

        handleVariantChange: function(event) {
            if (!event.target.matches('input[type="radio"]')) return;
            
            const picker = event.target.closest('variant-picker');
            if (!picker) return;

            this.getSelectedVariantId(picker).then(variantId => {
                if (variantId) {
                    this.updateComplementaryForm(variantId);
                }
            });
        },

        updateComplementaryForm: function(variantId) {
            const form = document.getElementById('product-form-complementary');
            if (!form) {
                console.log('Complementary form not found');
                return;
            }

            const picker = document.querySelector('variant-picker[data-is-complementary="true"]');
            if (!picker) {
                console.log('Complementary picker not found');
                return;
            }

            const productHandle = picker.getAttribute('handle');
            if (!productHandle) {
                console.log('Product handle not found');
                return;
            }

            fetch(`${Shopify.routes.root}products/${productHandle}.js`)
                .then(response => response.json())
                .then(productData => {
                    const variantData = productData.variants.find(v => v.id === variantId);
                    if (!variantData) {
                        console.log('Variant data not found for ID:', variantId);
                        return;
                    }

                    this.updateFormWithVariantData(form, variantId, variantData, productData);
                })
                .catch(error => {
                    console.error('Error fetching product data:', error);
                });
        },

        updateFormWithVariantData: function(form, variantId, variantData, productData) {
            // Update variant ID in form
            document.querySelector('.product-info__block-item form#product-form-complementary >input[name="id"]').value = variantId;
            
            // Update Shopify payment button variant params
            const shopifyCheckout = form.querySelector('shopify-accelerated-checkout');
            if (shopifyCheckout) {
                this.updateShopifyCheckoutVariant(shopifyCheckout, variantId);
            }

            // Update button state
            this.updateButtonState(variantData, productData);
        },

        updateShopifyCheckoutVariant: function(shopifyCheckout, variantId) {
            const currentParams = shopifyCheckout.getAttribute('variant-params');
            if (currentParams) {
                try {
                    const variantsList = JSON.parse(currentParams.replace(/&quot;/g, '"'));
                    if (variantsList && variantsList.length > 0) {
                        variantsList[0].id = variantId;
                        const updatedParams = JSON.stringify(variantsList).replace(/"/g, '&quot;');
                        shopifyCheckout.setAttribute('variant-params', updatedParams);
                    }
                } catch (e) {
                    console.error('Error updating Shopify checkout variant:', e);
                }
            }
        },

        updateButtonState: function(variantData, productData) {
            const updateButtonState = () => {
                const buyButtonsContainer = document.querySelector('.product-info__block-item[data-block-id="buy_buttons2"] buy-buttons');
                if (!buyButtonsContainer) {
                    setTimeout(updateButtonState, 100);
                    return;
                }

                const button = buyButtonsContainer.querySelector('button[type="submit"]');
                if (!button) return;

                if (variantData.available) {
                    this.setButtonToAddToCart(button, buyButtonsContainer);
                } else {
                    this.setButtonToSoldOut(button, buyButtonsContainer, variantData, productData);
                }
            };

            updateButtonState();
            Shopify?.PaymentButton?.init();
        },

        setButtonToAddToCart: function(button, container) {
            button.textContent = 'Add to Cart';
            button.disabled = false;
            button.classList.remove('button--outline');
            
            const paymentButtons = container.querySelectorAll('shopify-payment-button, .shopify-payment-button');
            paymentButtons.forEach(btn => btn.style.display = '');

            const waitlistButton = container.querySelector('.klaviyo-bis-trigger');
            if (waitlistButton) {
                waitlistButton.remove();
            }
        },

        setButtonToSoldOut: function(button, container, variantData, productData) {
            button.textContent = 'Sold Out';
            button.disabled = true;
            button.classList.remove('button--outline');

            const paymentButtons = container.querySelectorAll('shopify-payment-button, .shopify-payment-button');
            paymentButtons.forEach(btn => btn.style.display = 'none');

            if (!container.querySelector('.klaviyo-bis-trigger')) {
                this.createWaitlistButton(container, variantData, productData);
            }
        },

        createWaitlistButton: function(container, variantData, productData) {
            // Remove any existing Klaviyo container
            const existingContainer = document.getElementById('klaviyo-bis-container-complementary');
            if (existingContainer) {
                existingContainer.remove();
            }

            // Create a container for the Klaviyo button
            const klaviyoContainer = document.createElement('div');
            klaviyoContainer.id = 'klaviyo-bis-container-complementary';
            klaviyoContainer.setAttribute('data-product-type', 'complementary');
            container.appendChild(klaviyoContainer);

            // Create the waitlist button as an anchor tag
            const waitlistButton = document.createElement('a');
            waitlistButton.href = '#';
            waitlistButton.className = 'btn klaviyo-bis-trigger';
            waitlistButton.textContent = 'JOIN WAITLIST';
            waitlistButton.style.display = 'block';
            waitlistButton.style.textAlign = 'center';
            waitlistButton.style.margin = '0px';
            waitlistButton.style.width = 'auto';

            // Add click handler to prevent default behavior and create custom modal
            waitlistButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Create modal container
                const modal = document.createElement('div');
                modal.className = 'complementary-product-modal';

                // Create modal content
                const modalContent = document.createElement('div');
                modalContent.className = 'complementary-product-modal-content';

                // Create close button
                const closeButton = document.createElement('button');
                closeButton.className = 'complementary-product-close-button';
                closeButton.innerHTML = '&times;';

                // Handle close button click
                closeButton.addEventListener('click', () => {
                    modal.remove();
                });

                // Handle click outside modal
                modal.addEventListener('click', (e) => {
                    if (e.target === modal) {
                        modal.remove();
                    }
                });

                // Create form
                const form = document.createElement('form');
                form.className = 'complementary-product-modal-form';

                // Add product title
                const title = document.createElement('h3');
                title.className = 'complementary-product-modal-title';
                title.textContent = productData.title;

                // Add variant selector if there are multiple variants
                let variantSelect = null;
                let variantLabel = null;
                if (productData.variants && productData.variants.length > 1) {
                    variantLabel = document.createElement('label');
                    variantLabel.className = 'complementary-product-variant-label';
                    variantLabel.textContent = 'Register to receive a notification when this item comes back in stock.';

                    variantSelect = document.createElement('select');
                    variantSelect.className = 'complementary-product-form-control';

                    // Only add out-of-stock variants to the select
                    productData.variants
                        .filter(variant => !variant.available)
                        .forEach(variant => {
                            const option = document.createElement('option');
                            option.value = variant.id;
                            option.textContent = variant.title;
                            if (variant.id === variantData.id) {
                                option.selected = true;
                            }
                            variantSelect.appendChild(option);
                        });
                }

                // Add email input
                const emailInput = document.createElement('input');
                emailInput.type = 'email';
                emailInput.required = true;
                emailInput.placeholder = 'Email';
                emailInput.className = 'complementary-product-form-control complementary-product-input-lg';

                // Add submit button
                const submitButton = document.createElement('button');
                submitButton.type = 'submit';
                submitButton.className = 'complementary-product-submit-button';
                submitButton.textContent = 'Notify me when available';

                // Add form elements in the desired order
                form.appendChild(title);
                if (variantSelect && variantLabel) {
                    form.appendChild(variantLabel);
                    form.appendChild(variantSelect);
                }
                form.appendChild(emailInput);
                form.appendChild(submitButton);

                // Handle form submission
                form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    const email = emailInput.value;
                    const selectedVariantId = variantSelect ? variantSelect.value : variantData.id;

                    // Submit to Klaviyo
                    if (window.klaviyo) {
                        window.klaviyo.identify({
                            email: email
                        });

                        window.klaviyo.track('Back in Stock', {
                            'Product ID': productData.id,
                            'Variant ID': selectedVariantId,
                            'Product Name': productData.title,
                            'Variant Name': productData.variants.find(v => v.id === selectedVariantId)?.title || variantData.title
                        });

                        // Show success message
                        const successMessage = document.createElement('div');
                        successMessage.className = 'complementary-product-success-message';
                        successMessage.textContent = 'You\'re in! We\'ll let you know when it\'s back.';
                        form.innerHTML = '';
                        form.appendChild(successMessage);
                        setTimeout(() => modal.remove(), 2000);
                    }
                });

                // Assemble modal
                modalContent.appendChild(closeButton);
                modalContent.appendChild(form);
                modal.appendChild(modalContent);
                document.body.appendChild(modal);

                // Add fade in effect
                setTimeout(() => {
                    modal.style.opacity = '1';
                }, 0);
            });

            // Add the button to the container
            klaviyoContainer.appendChild(waitlistButton);

            // Load Klaviyo script
            this.loadKlaviyoScript();
        },

        setupVisibilityObserver: function(button) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        if (button.style.display === 'none') {
                            button.style.display = 'block';
                        }
                    }
                });
            });

            observer.observe(button, {
                attributes: true,
                attributeFilter: ['style']
            });
        },

        setupInitialVariant: function(picker) {
            const variants = this.getAllVariants(picker);
            if (variants.length > 0) {
                const defaultVariant = variants.find(v => v.available) || variants[0];
                if (defaultVariant?.id) {
                    this.updateComplementaryForm(defaultVariant.id);
                }
            }
        },

        init: function() {
            if (this.initialized) return;
            this.initialized = true;

            this.setupCartDrawer();
            this.setupVariantChangeListener();
            this.setupMutationObserver();
        },

        setupCartDrawer: function() {
            const buyButtons = document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"] button[type="submit"]');
            if (buyButtons?.[1]) {
                buyButtons[1].addEventListener('click', () => {
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                        setTimeout(() => cartDrawer.show(), 1000);
                    }
                });
            }
        },

        setupVariantChangeListener: function() {
            document.addEventListener('variant:change', (event) => {
                const picker = event.target.closest('variant-picker[data-is-complementary="true"]');
                if (picker) {
                    const form = document.getElementById('product-form-complementary');
                    if (form) {
                        const button = form.querySelector('button[type="submit"]');
                        if (button) {
                            const variant = event.detail.variant;
                            if (variant.available) {
                                this.setButtonToAddToCart(button, form);
                            } else {
                                this.setButtonToSoldOut(button, form, variant, event.detail.product);
                            }
                        }
                    }
                }
            });
        },

        setupMutationObserver: function() {
            const observer = new MutationObserver((mutations) => {
                if (this.isProcessing) return;
                
                const shouldEnhance = mutations.some(mutation => 
                    mutation.type === 'childList' && 
                    mutation.target.querySelector('variant-picker:not([data-enhanced])')
                );

                if (shouldEnhance) {
                    this.enhanceComplementaryVariantPickers();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    };

    // Initialize the complementary product functionality
    const initializeComplementaryProduct = () => {
        if (!ComplementaryProductFix.initialized) {
            ComplementaryProductFix.init();
            ComplementaryProductFix.enhanceComplementaryVariantPickers();
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeComplementaryProduct);
    } else {
        initializeComplementaryProduct();
    }
})();
